import { useFormContext } from 'react-hook-form'

import { AssignJourneyToCenterInput } from '../../../../lib/types/models/center/center-input'
import ValidationButtons, {
  ValidationButtonsBaseFormProps
} from '../../../elements/validation-buttons'
import CenterJourneyCard from './center-journey-card'
import TotalNumberOfChildren from './total-number-of-children'

const CenterJourneyInformation = ({
  buttonsConfig
}: ValidationButtonsBaseFormProps<AssignJourneyToCenterInput>) => {
  const form = useFormContext<AssignJourneyToCenterInput>()
  const centerToJourneys = form.watch('centerToJourneys')

  return (
    <div>
      <TotalNumberOfChildren />
      <div className="h-4" />
      <div className="flex flex-col gap-4">
        {centerToJourneys.map((centerToJourney) => (
          <CenterJourneyCard
            key={centerToJourney.journey.id}
            centerToJourney={centerToJourney}
            onCenterToJourneyChange={(centerToJourney) => {
              const updatedCenterToJourneys = centerToJourneys.map((ctj) =>
                ctj.journey.id === centerToJourney.journey.id ? centerToJourney : ctj
              )
              form.setValue('centerToJourneys', updatedCenterToJourneys)
            }}
          />
        ))}
      </div>
      <div className="h-4" />

      <div className="h-4" />
      <ValidationButtons buttonsConfig={buttonsConfig} />
    </div>
  )
}

export default CenterJourneyInformation
